import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../dist/asyncToGenerator-c002e3ca.esm.js';
import { _ as _slicedToArray } from '../../dist/slicedToArray-5badcb6e.esm.js';
import dayjs from 'dayjs';
import { useState } from 'react';

var useApi = function useApi(apiFunc, envConfig, forceJSONParsing) {
  var exceptionOnTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var defaultDuration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 29000;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    response = _useState4[0],
    setResponse = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = useState(dayjs().toDate().getTime()),
    _useState12 = _slicedToArray(_useState11, 2),
    lastUpdate = _useState12[0],
    setLastUpdate = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    wasInvoked = _useState14[0],
    setWasInvoked = _useState14[1];
  var apiRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _response2,
        _response2$originalEr,
        _response,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setWasInvoked(true);
            setLoading(true);
            _context.next = 5;
            return apiFunc.apply(void 0, _args);
          case 5:
            _response2 = _context.sent;
            if (!(!(_response2 !== null && _response2 !== void 0 && _response2.data) || _response2 !== null && _response2 !== void 0 && _response2.problem)) {
              _context.next = 15;
              break;
            }
            setData((_response2 === null || _response2 === void 0 ? void 0 : _response2.data) || []);
            setErrorMessage(_response2 === null || _response2 === void 0 ? void 0 : (_response2$originalEr = _response2.originalError) === null || _response2$originalEr === void 0 ? void 0 : _response2$originalEr.message);
            setLoading(false);
            setError(true);
            setResponse(_response2);
            if (!(exceptionOnTimeout && (_response2 === null || _response2 === void 0 ? void 0 : _response2.duration) > defaultDuration)) {
              _context.next = 14;
              break;
            }
            throw new Error("The request timed out");
          case 14:
            return _context.abrupt("return", _response2.data);
          case 15:
            setError(false);
            setErrorMessage(null);
            _response = _response2 === null || _response2 === void 0 ? void 0 : _response2.data; // check is response is a string of JSON
            if (forceJSONParsing && typeof _response === "string") {
              _response = JSON.parse(_response);
            }
            setData(_response);
            setResponse(_response2);
            return _context.abrupt("return", _response2.data);
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](0);
            throw _context.t0;
          case 27:
            _context.prev = 27;
            setLastUpdate(dayjs().toDate().getTime());
            setLoading(false);
            return _context.finish(27);
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 24, 27, 31]]);
    }));
    return function apiRequest() {
      return _ref.apply(this, arguments);
    };
  }();
  var request = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(onRequestCompleted, onRequestError) {
      var _response3$data,
        _len,
        args,
        _key,
        _response3,
        _response3$originalEr,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setWasInvoked(true);
            setLoading(true);
            for (_len = _args2.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = _args2[_key];
            }
            _context2.next = 6;
            return apiFunc.apply(void 0, args.concat([envConfig]));
          case 6:
            _response3 = _context2.sent;
            if (!(!(_response3 !== null && _response3 !== void 0 && _response3.ok) || _response3 !== null && _response3 !== void 0 && (_response3$data = _response3.data) !== null && _response3$data !== void 0 && _response3$data.includes("<html>\r\n<head><title>502 Bad Gateway"))) {
              _context2.next = 13;
              break;
            }
            setResponse(_response3);
            setData([]);
            onRequestError && onRequestError();
            setErrorMessage(_response3 === null || _response3 === void 0 ? void 0 : (_response3$originalEr = _response3.originalError) === null || _response3$originalEr === void 0 ? void 0 : _response3$originalEr.message);
            return _context2.abrupt("return", setError(true));
          case 13:
            setError(false);
            setErrorMessage(null);
            setData(_response3.data);
            setResponse(_response3);
            onRequestCompleted && onRequestCompleted(_response3.data);
            return _context2.abrupt("return", _response3.data);
          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0;
          case 24:
            _context2.prev = 24;
            setLastUpdate(dayjs());
            setLoading(false);
            return _context2.finish(24);
          case 28:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 21, 24, 28]]);
    }));
    return function request(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var optimisticDataUpdate = function optimisticDataUpdate(data) {
    setData(data);
  };
  return {
    request: request,
    apiRequest: apiRequest,
    data: data,
    optimisticDataUpdate: optimisticDataUpdate,
    lastUpdate: lastUpdate,
    error: error,
    loading: loading,
    response: response,
    errorMessage: errorMessage,
    wasInvoked: wasInvoked
  };
};

export { useApi as default };
